export const getEventItemModel = () => ({
  id: null,
  name: "",
  status: "",
  start_date: null,
  end_date: null,
});
